module.exports = __webpack_public_path__ + "static/media/FC_Smaller-Glow.418c4552.png";